import * as R from "ramda";

import { reportError } from "services/errorReporter";
import { capitalize } from "utils/format";

import * as BuildingTypeField from "./BuildingTypeField";
import * as ButtonField from "./ButtonField";
import * as CalendarField from "./CalendarField";
import * as CheckboxField from "./CheckboxField";
import * as CurrencyField from "./CurrencyField";
import * as DateTime from "./DateTime";
import * as EmailField from "./EmailField";
import * as EventGeomsField from "./EventGeomsField";
import * as EventLocationsFieldLegacy from "./EventLocationsFieldLegacy";
import * as EventRoutesFieldLegacy from "./EventRoutesFieldLegacy";
import * as EventTimesField from "./EventTimesField";
import * as FileField from "./FileField";
import * as FloatField from "./FloatField";
import * as InstructionField from "./InstructionField";
import * as IntegerField from "./IntegerField";
import * as MultiSelectCheckboxField from "./MultiSelectCheckboxField";
import * as OnlyDisabledAddressField from "./OnlyDisabledAddressField";
import * as OverridesField from "./OverridesField";
import * as RadioButtonField from "./RadioButtonField";
import * as RequirementCatalogField from "./RequirementCatalogField";
import * as SelectField from "./SelectField";
import * as SensitiveField from "./SensitiveField";
import * as SignatureField from "./SignatureField";
import * as TelephoneField from "./TelephoneField";
import * as TermsAndConditionsField from "./TermsAndConditionsField";
import * as TextAreaField from "./TextAreaField";
import * as TextField from "./TextField";
import * as UseCodeField from "./UseCodeField";
import * as YesNoField from "./YesNoField";
import * as ZoningField from "./ZoningField";

const DisabledNoneField = () => null;

const getInputField = (inputType) => {
  switch (inputType) {
    case "address":
    case "zoned_address":
      // Handle circular dependency
      return require("./ZonedAddressField");
    case "building_type":
      return BuildingTypeField;
    case "button":
      return ButtonField;
    case "check_box":
      return CheckboxField;
    case "component":
      // Handle circular dependency
      return require("./ComponentField");
    case "currency":
      return CurrencyField;
    case "date_select":
      return CalendarField;
    case "date_time":
      return DateTime;
    case "email":
      return EmailField;
    case "event_geom":
      return EventGeomsField;
    case "event_location":
      return EventLocationsFieldLegacy;
    case "event_route":
      return EventRoutesFieldLegacy;
    case "event_time":
      return EventTimesField;
    case "file":
      return FileField;
    case "float":
      return FloatField;
    case "instruction":
      return InstructionField;
    case "integer":
      return IntegerField;
    case "list":
      // Handle circular dependency
      return require("./ListField");
    case "multi_select_list":
      return MultiSelectCheckboxField;
    case "none":
      return { disabled: DisabledNoneField };
    case "only_disabled_address":
      return OnlyDisabledAddressField;
    case "overrides":
      return OverridesField;
    case "radio_button":
      return RadioButtonField;
    case "requirement_catalog":
      return RequirementCatalogField;
    case "select":
      return SelectField;
    case "sensitive":
      return SensitiveField;
    case "signature":
      return SignatureField;
    case "telephone":
      return TelephoneField;
    case "terms_and_condition":
      return TermsAndConditionsField;
    case "text":
      return TextField;
    case "text_area":
      return TextAreaField;
    case "use_code":
      return UseCodeField;
    case "yes_no":
      return YesNoField;
    case "zoning":
      return ZoningField;
    default: {
      reportError(new Error(`unsupported field type: ${inputType}`), {
        context: {
          component: "fieldLookup",
          severity: "warning",
        },
        params: { inputType },
      });
      return TextField;
    }
  }
};

const fieldForInputType = (inputType, { behaviorType = "default" } = {}) => {
  const FieldComponents = getInputField(inputType);
  const behaviorComponent = behaviorType !== "default" ? capitalize(behaviorType) : behaviorType;

  if (R.has(behaviorComponent, FieldComponents)) return FieldComponents[behaviorComponent];
  if (behaviorType === "disabled") return TextField.Disabled;
  if (behaviorType === "issued") {
    if (R.has("Disabled", FieldComponents)) return FieldComponents.Disabled;
    return TextField.Issued;
  }

  return FieldComponents.default;
};

export default fieldForInputType;
